module.exports = "/static/assets/7499217c0e062f21abee242378b8bad9.png";